module.exports = __webpack_public_path__ + "static/img/9.27a1419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/9.png
// module id = O/jY
// module chunks = 0